"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
export default function DownloadSchedule() {
  const {
    ref: subtitleRef,
    isVisible: subtitleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/schedule.pdf";
    link.download = "PolyCon_Schedule.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return;
}